module.exports = __webpack_public_path__ + "static/media/centralAtendIcon.70d5e208.svg";